// extracted by mini-css-extract-plugin
export default {"slim":"Table_slim__yZkiJ"};